import React, { useEffect } from 'react';
import { usePDF } from '@react-pdf/renderer';
import GenerateConventionPDF from './generate.convention.PDF';

const PdfViewer = ({ data, currUser, onComplete }) => {
  // Le hook usePDF génère le document en arrière-plan
  const [instance, updateInstance] = usePDF({
    document: <GenerateConventionPDF data={data} currUser={currUser} />,
  });

  // Ce useEffect s'active dès que l'URL du PDF est prête
  useEffect(() => {
    if (instance.url && !instance.loading) {
      // Ouvre le PDF dans un nouvel onglet
      window.open(instance.url, '_blank');
      // Prévient le composant parent que c'est terminé
      onComplete();
    }
  }, [instance.url, instance.loading, onComplete]);

  // Pendant la génération, on peut afficher un message
  if (instance.loading) {
    return <div style={{ color: '#49708C', fontWeight: 'bold' }}>Génération du PDF en cours...</div>;
  }

  if (instance.error) {
    console.error("Erreur lors de la génération du PDF:", instance.error);
    return <div style={{ color: 'red' }}>Une erreur est survenue.</div>;
  }

  return null;
};

export default PdfViewer;